import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, GlobeIcon, LayoutIcon, CrownIcon } from 'lucide-react';
const packages = [{
  name: 'Starter Package',
  subtitle: 'Basic Website',
  price: '$199 – $500',
  features: ['1–3 web pages (Home, About, Contact)', 'Basic contact form', 'Social media links'],
  icon: <GlobeIcon size={28} data-id="element-167" />,
  highlighted: false
}, {
  name: 'Standard Package',
  subtitle: 'Small Business Website',
  price: '$600 – $1,200',
  features: ['4–7 pages (Home, About, Services, Blog, Contact, etc.)', 'Custom layout design', 'Mobile responsiveness', 'Contact forms with basic automation', 'Google Maps integration', 'CMS setup (WordPress)', '2–3 rounds of revisions'],
  icon: <LayoutIcon size={28} data-id="element-168" />,
  highlighted: false
}, {
  name: 'Premium Package',
  subtitle: 'Advanced Website',
  price: '$1,500 – $3,000',
  features: ['8–15 pages', 'Advanced custom design (UI/UX)', 'Blog integration', 'E-commerce functionality (optional)', 'Booking system or forms', 'CMS training (video or written guide)', 'Google Analytics setup', 'Social media feed integration', 'Unlimited revisions'],
  icon: <CrownIcon size={28} data-id="element-169" />,
  highlighted: true
}];
export function Pricing() {
  return <section id="pricing" className="py-20 bg-sum-light" data-id="element-170">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-171">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="text-center mb-16" data-id="element-172">
          <h2 className="text-3xl md:text-4xl font-extrabold text-sum-charcoal mb-4" data-id="element-173">
            Simple, Transparent Pricing
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-174">
            Affordable packages designed to get your business online and
            growing.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-5xl mx-auto" data-id="element-175">
          {packages.map((pkg, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className={`bg-white rounded-2xl shadow-lg overflow-hidden w-full flex flex-col ${pkg.highlighted ? 'border-2 border-sum-gold ring-4 ring-sum-gold/20 md:scale-105' : 'border border-gray-100'}`} data-id="element-176">
              <div className={`p-6 text-center ${pkg.highlighted ? 'bg-sum-charcoal' : 'bg-sum-green'}`} data-id="element-177">
                {pkg.highlighted && <span className="inline-block bg-sum-gold text-sum-charcoal text-xs font-bold uppercase tracking-wider px-3 py-1 rounded-full mb-3" data-id="element-178">
                    Most Popular
                  </span>}
                <div className="inline-flex items-center justify-center w-14 h-14 rounded-full bg-white/20 text-white mb-4" data-id="element-179">
                  {pkg.icon}
                </div>
                <h3 className="text-2xl font-bold text-white" data-id="element-180">{pkg.name}</h3>
                <p className={`text-sm mt-1 ${pkg.highlighted ? 'text-gray-300' : 'text-green-100'}`} data-id="element-181">
                  {pkg.subtitle}
                </p>
              </div>

              <div className="p-8 flex flex-col flex-1" data-id="element-182">
                <div className="text-center mb-8" data-id="element-183">
                  <span className="text-3xl font-extrabold text-sum-charcoal" data-id="element-184">
                    {pkg.price}
                  </span>
                </div>

                <ul className="space-y-4 mb-8 flex-1" data-id="element-185">
                  {pkg.features.map((feature, i) => <li key={i} className="flex items-start" data-id="element-186">
                      <CheckIcon size={20} className="text-sum-green mt-0.5 mr-3 flex-shrink-0" data-id="element-187" />
                      <span className="text-gray-700" data-id="element-188">{feature}</span>
                    </li>)}
                </ul>

                <a href="#contact" className={`block w-full text-center font-bold py-3 rounded-lg shadow-md hover:shadow-lg transition-all transform hover:-translate-y-0.5 ${pkg.highlighted ? 'bg-sum-gold hover:bg-yellow-500 text-sum-charcoal' : 'bg-sum-gold hover:bg-yellow-500 text-sum-charcoal'}`} data-id="element-189">
                  Buy Now
                </a>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}